const semanticClassNames = {
  icon: 'radio__icon',
} as const;

export default semanticClassNames;
